import { useState, useEffect } from "react";
import { supabase } from "./supabase";

const CATEGORIES = ["Biscuits","Chips","Namkeen","Noodles","Instant","Chocolate","Cereals","Paneer & Fresh Dairy","Dairy","Health Drinks","Juice","Soft Drinks","Energy","Protein","Spreads","Sauces","Oils","Bakery","Patanjali","Health Snacks","Health & Ayurveda","Tea & Coffee","Staples","Ready to Eat","Supplements","Ice Cream"];

export default function AdminPage({ onExit }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ emoji: "", name: "", brand: "", category: "Biscuits", tags: "", health_score: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { fetchProducts(); }, []);

  async function fetchProducts() {
    setLoading(true);
    const { data } = await supabase.from('products').select('*').order('name');
    setProducts(data || []);
    setLoading(false);
  }

  function openAdd() {
    setEditing(null);
    setForm({ emoji: "", name: "", brand: "", category: "Biscuits", tags: "", health_score: "" });
    setShowForm(true);
  }

  function openEdit(p) {
    setEditing(p.id);
    setForm({ emoji: p.emoji || "", name: p.name || "", brand: p.brand || "", category: p.category || "Biscuits", tags: (p.tags || []).join(", "), health_score: p.health_score || "" });
    setShowForm(true);
  }

  async function save() {
    if (!form.name) return alert("Name is required");
    setSaving(true);
    const payload = {
      emoji: form.emoji,
      name: form.name,
      brand: form.brand,
      category: form.category,
      tags: form.tags ? form.tags.split(",").map(t => t.trim()) : [],
      health_score: form.health_score ? parseFloat(form.health_score) : null
    };
    if (editing) {
      await supabase.from('products').update(payload).eq('id', editing);
    } else {
      await supabase.from('products').insert(payload);
    }
    setSaving(false);
    setShowForm(false);
    fetchProducts();
  }

  async function deleteProduct(id) {
    if (!window.confirm("Delete this product?")) return;
    await supabase.from('products').delete().eq('id', id);
    fetchProducts();
  }

  const filtered = products.filter(p =>
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.brand?.toLowerCase().includes(search.toLowerCase()) ||
    p.category?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f2f5f2", fontFamily: "inherit" }}>
      {/* Header */}
      <div style={{ background: "linear-gradient(135deg,#1a4a2e,#2d7a4f)", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ color: "#fff", fontWeight: 800, fontSize: 20 }}>🛡️ NutriScan Admin</div>
        <button onClick={onExit} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>← Exit</button>
      </div>

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: 24 }}>
        {/* Stats */}
        <div style={{ background: "#fff", borderRadius: 12, padding: 20, marginBottom: 20, display: "flex", gap: 32 }}>
          <div><div style={{ fontSize: 28, fontWeight: 800, color: "#1a4a2e" }}>{products.length}</div><div style={{ color: "#666", fontSize: 14 }}>Total Products</div></div>
          <div><div style={{ fontSize: 28, fontWeight: 800, color: "#1a4a2e" }}>{[...new Set(products.map(p => p.category))].length}</div><div style={{ color: "#666", fontSize: 14 }}>Categories</div></div>
        </div>

        {/* Toolbar */}
        <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
          <input
            placeholder="Search products..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ flex: 1, padding: "10px 14px", borderRadius: 8, border: "1.5px solid #ddd", fontSize: 14, fontFamily: "inherit" }}
          />
          <button onClick={openAdd} style={{ background: "#1a4a2e", color: "#fff", border: "none", padding: "10px 20px", borderRadius: 8, fontWeight: 700, cursor: "pointer", fontSize: 14 }}>+ Add Product</button>
        </div>

        {/* Table */}
        {loading ? (
          <div style={{ textAlign: "center", padding: 40, color: "#666" }}>Loading...</div>
        ) : (
          <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f8faf8" }}>
                  {["", "Name", "Brand", "Category", "Health Score", "Actions"].map(h => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 13, fontWeight: 700, color: "#444", borderBottom: "1.5px solid #eee" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(p => (
                  <tr key={p.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
                    <td style={{ padding: "10px 16px", fontSize: 20 }}>{p.emoji}</td>
                    <td style={{ padding: "10px 16px", fontWeight: 600, fontSize: 14 }}>{p.name}</td>
                    <td style={{ padding: "10px 16px", fontSize: 14, color: "#666" }}>{p.brand}</td>
                    <td style={{ padding: "10px 16px" }}><span style={{ background: "#e8f5e9", color: "#1a4a2e", padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{p.category}</span></td>
                    <td style={{ padding: "10px 16px", fontSize: 14, fontWeight: 700, color: p.health_score >= 7 ? "#2d7a4f" : p.health_score >= 5 ? "#f59e0b" : "#ef4444" }}>{p.health_score || "—"}</td>
                    <td style={{ padding: "10px 16px" }}>
                      <button onClick={() => openEdit(p)} style={{ background: "#e8f5e9", border: "none", color: "#1a4a2e", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, marginRight: 6 }}>Edit</button>
                      <button onClick={() => deleteProduct(p.id)} style={{ background: "#fee2e2", border: "none", color: "#ef4444", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 }}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filtered.length === 0 && <div style={{ textAlign: "center", padding: 40, color: "#666" }}>No products found</div>}
          </div>
        )}
      </div>

      {/* Add/Edit Form Modal */}
      {showForm && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 480, maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 20 }}>{editing ? "Edit Product" : "Add Product"}</div>
            {[["emoji", "Emoji"], ["name", "Name *"], ["brand", "Brand"], ["tags", "Tags (comma separated)"], ["health_score", "Health Score (0-10)"]].map(([k, lbl]) => (
              <div key={k} style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, color: "#444" }}>{lbl}</div>
                <input
                  value={form[k]}
                  onChange={e => setForm(p => ({ ...p, [k]: e.target.value }))}
                  placeholder={lbl}
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #ddd", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box" }}
                />
              </div>
            ))}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, color: "#444" }}>Category</div>
              <select value={form.category} onChange={e => setForm(p => ({ ...p, category: e.target.value }))} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #ddd", fontSize: 14, fontFamily: "inherit" }}>
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => setShowForm(false)} style={{ flex: 1, padding: 12, borderRadius: 8, border: "1.5px solid #ddd", background: "#fff", cursor: "pointer", fontWeight: 600 }}>Cancel</button>
              <button onClick={save} disabled={saving} style={{ flex: 1, padding: 12, borderRadius: 8, border: "none", background: "#1a4a2e", color: "#fff", cursor: "pointer", fontWeight: 700 }}>{saving ? "Saving..." : "Save"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}